module.exports = __webpack_public_path__ + "img/3_Middle-esophagus.b93e4724.png";